export const GOOGLE_SHEET_URL = "https://script.google.com/macros/s/AKfycbyvMow2EghqwMMdul4WtF9m-A-TTpL4PMEGJqyspJXosuQEQ85yuWr5KnPRMAVOfmFPhA/exec";
export const GOOGLE_SHEET_URL_TWO = "https://script.google.com/macros/s/AKfycbyvMow2EghqwMMdul4WtF9m-A-TTpL4PMEGJqyspJXosuQEQ85yuWr5KnPRMAVOfmFPhA/exec";
